import { memo } from 'react';
import { CustomTheme } from '../../theme/customTheme';

type Props = {
  size?: number;
  color?: string;
};

function TrailerIcon({ size = 50, color = CustomTheme.colors.contentPrimary }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      zoomAndPan="magnify"
      viewBox="0 0 810 809.999993"
      height={size}
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="928f18ed27">
          <path
            d="M 294.082031 127.5625 L 516.082031 127.5625 L 516.082031 155 L 294.082031 155 Z M 294.082031 127.5625 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="4384d23dd4">
          <path
            d="M 294.082031 127.5625 L 516.082031 127.5625 L 516.082031 160 L 294.082031 160 Z M 294.082031 127.5625 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="9344fa60f7">
          <path
            d="M 294.082031 127.5625 L 302 127.5625 L 302 140 L 294.082031 140 Z M 294.082031 127.5625 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="6b836c2d78">
          <path
            d="M 294.082031 127.5625 L 308 127.5625 L 308 145 L 294.082031 145 Z M 294.082031 127.5625 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="86fcef1e21">
          <path
            d="M 294.082031 131 L 516.082031 131 L 516.082031 682.5625 L 294.082031 682.5625 Z M 294.082031 131 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="856ead7c37">
          <path
            d="M 294.082031 127.5625 L 516.082031 127.5625 L 516.082031 682.5625 L 294.082031 682.5625 Z M 294.082031 127.5625 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="5d58b74511">
          <path
            d="M 294.082031 156 L 516.082031 156 L 516.082031 241 L 294.082031 241 Z M 294.082031 156 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="2f21d2dad2">
          <path
            d="M 294.082031 151 L 516.082031 151 L 516.082031 246 L 294.082031 246 Z M 294.082031 151 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="8e4a41b1c9">
          <path
            d="M 294.082031 410 L 516.082031 410 L 516.082031 553 L 294.082031 553 Z M 294.082031 410 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="91b0165c4e">
          <path
            d="M 294.082031 405 L 516.082031 405 L 516.082031 558 L 294.082031 558 Z M 294.082031 405 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="1b341b592a">
          <path
            d="M 294.082031 566 L 516.082031 566 L 516.082031 666 L 294.082031 666 Z M 294.082031 566 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="45262f1aba">
          <path
            d="M 294.082031 561 L 516.082031 561 L 516.082031 671 L 294.082031 671 Z M 294.082031 561 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="34928fb3b3">
          <path
            d="M 294.082031 255 L 516.082031 255 L 516.082031 397 L 294.082031 397 Z M 294.082031 255 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="fb857bd0c6">
          <path
            d="M 294.082031 249 L 516.082031 249 L 516.082031 402 L 294.082031 402 Z M 294.082031 249 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#928f18ed27)">
        <path
          fill="#f04625"
          d="M 233.71875 154.652344 C 230.765625 49.046875 227.808594 -58.433594 224.863281 -150.933594 C 224.144531 -172.089844 245.800781 -187.070312 270.714844 -194.542969 C 379.230469 -208.675781 435.121094 -208.675781 558.558594 -194.542969 C 585.820312 -187.335938 605.140625 -172.089844 604.429688 -150.933594 C 601.472656 -58.433594 598.527344 49.046875 595.574219 154.652344 L 233.71875 154.652344 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#4384d23dd4)">
        <path
          fill="#fdfdfd"
          d="M 233.71875 154.652344 L 238.992188 154.507812 C 236.039062 48.902344 233.082031 -58.578125 230.125 -151.109375 L 230.125 -151.121094 C 230.117188 -151.410156 230.117188 -151.6875 230.117188 -151.957031 C 230.125 -156.191406 231.1875 -160.046875 233.195312 -163.75 C 236.191406 -169.285156 241.453125 -174.441406 248.28125 -178.832031 C 255.101562 -183.234375 263.421875 -186.839844 272.21875 -189.480469 L 270.714844 -194.542969 L 271.394531 -189.304688 C 325.542969 -196.355469 366.367188 -199.863281 409.042969 -199.863281 C 451.710938 -199.863281 496.324219 -196.355469 557.960938 -189.296875 L 558.558594 -194.542969 L 557.222656 -189.429688 C 570.023438 -186.070312 580.792969 -180.832031 588.054688 -174.398438 C 591.699219 -171.191406 594.472656 -167.707031 596.335938 -164.007812 C 598.1875 -160.304688 599.167969 -156.390625 599.175781 -152.070312 C 599.175781 -151.761719 599.167969 -151.441406 599.15625 -151.089844 L 599.15625 -151.109375 C 596.199219 -58.578125 593.253906 48.902344 590.300781 154.507812 L 595.574219 154.652344 L 595.574219 149.375 L 233.71875 149.375 L 233.71875 154.652344 L 238.992188 154.507812 L 233.71875 154.652344 L 233.71875 159.929688 L 595.574219 159.929688 C 598.414062 159.929688 600.761719 157.652344 600.847656 154.796875 C 603.800781 49.203125 606.746094 -58.277344 609.703125 -150.769531 L 609.703125 -150.792969 C 609.710938 -151.203125 609.722656 -151.636719 609.722656 -152.070312 C 609.722656 -158.027344 608.3125 -163.675781 605.746094 -168.757812 C 601.894531 -176.398438 595.574219 -182.738281 587.714844 -187.839844 C 579.835938 -192.953125 570.382812 -196.871094 559.910156 -199.644531 L 559.15625 -199.78125 C 497.363281 -206.863281 452.308594 -210.417969 409.042969 -210.417969 C 365.769531 -210.417969 324.390625 -206.863281 270.035156 -199.769531 C 269.722656 -199.726562 269.496094 -199.6875 269.199219 -199.59375 C 256.429688 -195.757812 244.371094 -190.046875 235.171875 -182.242188 C 230.578125 -178.335938 226.695312 -173.871094 223.9375 -168.800781 C 221.167969 -163.730469 219.558594 -158.027344 219.570312 -151.957031 C 219.570312 -151.554688 219.582031 -151.152344 219.589844 -150.761719 L 219.589844 -150.769531 C 222.535156 -58.277344 225.492188 49.203125 228.449219 154.796875 C 228.53125 157.652344 230.867188 159.929688 233.71875 159.929688 L 233.71875 154.652344 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#9344fa60f7)">
        <path
          fill={color}
          d="M 268.476562 14.328125 L 301.734375 97.160156 L 301.734375 139.714844 L 271.425781 139.714844 L 268.476562 14.328125 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#6b836c2d78)">
        <path
          fill="#fdfdfd"
          d="M 268.476562 14.328125 L 263.585938 16.296875 L 296.460938 98.179688 L 296.460938 134.425781 L 276.574219 134.425781 L 273.75 14.203125 L 268.476562 14.328125 L 263.585938 16.296875 L 268.476562 14.328125 L 263.207031 14.449219 L 266.152344 139.828125 C 266.210938 142.695312 268.5625 144.984375 271.425781 144.984375 L 301.734375 144.984375 C 303.144531 144.984375 304.460938 144.4375 305.460938 143.445312 C 306.449219 142.445312 307.003906 141.117188 307.003906 139.714844 L 307.003906 97.160156 C 307.003906 96.488281 306.871094 95.800781 306.625 95.191406 L 273.371094 12.359375 C 272.421875 9.988281 269.910156 8.648438 267.417969 9.152344 C 264.925781 9.667969 263.152344 11.90625 263.207031 14.449219 L 268.476562 14.328125 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#86fcef1e21)">
        <path
          fill={color}
          d="M 187.40625 662.820312 C 187.40625 678.058594 201.558594 690.410156 218.992188 690.410156 L 610.289062 690.410156 C 627.734375 690.410156 641.863281 678.058594 641.863281 662.820312 L 641.863281 159.167969 C 641.863281 143.921875 627.734375 131.582031 610.289062 131.582031 L 218.992188 131.582031 C 201.558594 131.582031 187.40625 143.921875 187.40625 159.167969 L 187.40625 662.820312 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#856ead7c37)">
        <path
          fill="#fdfdfd"
          d="M 187.40625 662.820312 L 182.136719 662.820312 C 182.125 672.109375 186.492188 680.472656 193.195312 686.304688 C 199.921875 692.171875 209.035156 695.6875 218.992188 695.6875 L 610.289062 695.6875 C 620.257812 695.6875 629.371094 692.171875 636.085938 686.304688 C 642.792969 680.472656 647.148438 672.109375 647.136719 662.820312 L 647.136719 159.167969 C 647.148438 149.871094 642.792969 141.519531 636.085938 135.675781 C 629.371094 129.820312 620.257812 126.304688 610.289062 126.304688 L 218.992188 126.304688 C 209.035156 126.304688 199.921875 129.820312 193.195312 135.675781 C 186.492188 141.519531 182.136719 149.871094 182.136719 159.167969 L 182.136719 662.820312 L 192.679688 662.820312 L 192.679688 159.167969 C 192.691406 153.21875 195.410156 147.777344 200.125 143.632812 C 204.84375 139.507812 211.527344 136.847656 218.992188 136.847656 L 610.289062 136.847656 C 617.765625 136.847656 624.441406 139.507812 629.15625 143.632812 C 633.875 147.777344 636.582031 153.21875 636.59375 159.167969 L 636.59375 662.820312 C 636.582031 668.769531 633.875 674.203125 629.15625 678.347656 C 624.441406 682.472656 617.765625 685.128906 610.289062 685.128906 L 218.992188 685.128906 C 211.527344 685.128906 204.84375 682.472656 200.125 678.347656 C 195.410156 674.203125 192.691406 668.769531 192.679688 662.820312 L 187.40625 662.820312 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#5d58b74511)">
        <path
          fill={color}
          d="M 207.644531 181.578125 C 207.644531 167.695312 220.519531 156.445312 236.410156 156.445312 L 592.875 156.445312 C 608.765625 156.445312 621.636719 167.695312 621.636719 181.578125 L 621.636719 240.609375 L 207.644531 240.609375 L 207.644531 181.578125 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#2f21d2dad2)">
        <path
          fill="#fdfdfd"
          d="M 207.644531 181.578125 L 212.917969 181.578125 C 212.917969 176.3125 215.316406 171.488281 219.527344 167.785156 C 223.742188 164.105469 229.703125 161.726562 236.410156 161.726562 L 592.875 161.726562 C 599.570312 161.726562 605.542969 164.105469 609.753906 167.785156 C 613.957031 171.488281 616.367188 176.3125 616.367188 181.578125 L 616.367188 235.332031 L 212.917969 235.332031 L 212.917969 181.578125 L 202.371094 181.578125 L 202.371094 240.609375 C 202.371094 242.019531 202.917969 243.339844 203.917969 244.339844 C 204.914062 245.339844 206.234375 245.886719 207.644531 245.886719 L 621.636719 245.886719 C 623.050781 245.886719 624.367188 245.339844 625.367188 244.339844 C 626.367188 243.339844 626.910156 242.019531 626.910156 240.609375 L 626.910156 181.578125 C 626.921875 172.972656 622.886719 165.230469 616.683594 159.839844 C 610.476562 154.414062 602.0625 151.179688 592.875 151.167969 L 236.410156 151.167969 C 227.210938 151.179688 218.808594 154.414062 212.597656 159.839844 C 206.398438 165.230469 202.359375 172.972656 202.371094 181.578125 L 207.644531 181.578125 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#8e4a41b1c9)">
        <path
          fill={color}
          d="M 621.636719 410.996094 L 621.636719 552.476562 L 207.644531 552.476562 L 207.644531 410.996094 L 621.636719 410.996094 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#91b0165c4e)">
        <path
          fill="#fdfdfd"
          d="M 621.636719 410.996094 L 616.367188 410.996094 L 616.367188 547.195312 L 212.917969 547.195312 L 212.917969 416.273438 L 621.636719 416.273438 L 621.636719 410.996094 L 616.367188 410.996094 L 621.636719 410.996094 L 621.636719 405.71875 L 207.644531 405.71875 C 206.253906 405.71875 204.894531 406.273438 203.917969 407.261719 C 202.929688 408.242188 202.371094 409.601562 202.371094 410.996094 L 202.371094 552.476562 C 202.371094 553.878906 202.917969 555.207031 203.917969 556.195312 C 204.914062 557.195312 206.234375 557.742188 207.644531 557.742188 L 621.636719 557.742188 C 623.050781 557.742188 624.367188 557.195312 625.367188 556.195312 C 626.367188 555.207031 626.910156 553.878906 626.910156 552.476562 L 626.910156 410.996094 C 626.910156 409.601562 626.355469 408.242188 625.367188 407.261719 C 624.386719 406.285156 623.027344 405.71875 621.636719 405.71875 L 621.636719 410.996094 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#1b341b592a)">
        <path
          fill={color}
          d="M 621.636719 640.398438 C 621.636719 654.285156 608.765625 665.542969 592.875 665.542969 L 236.410156 665.542969 C 220.519531 665.542969 207.644531 654.285156 207.644531 640.398438 L 207.644531 566.929688 L 621.636719 566.929688 L 621.636719 640.398438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#45262f1aba)">
        <path
          fill="#fdfdfd"
          d="M 621.636719 640.398438 L 616.367188 640.398438 C 616.367188 645.679688 613.957031 650.492188 609.742188 654.195312 C 605.542969 657.875 599.570312 660.265625 592.875 660.265625 L 236.410156 660.265625 C 229.714844 660.265625 223.742188 657.875 219.539062 654.195312 C 215.316406 650.492188 212.917969 645.679688 212.917969 640.398438 L 212.917969 572.207031 L 616.367188 572.207031 L 616.367188 640.398438 L 626.910156 640.398438 L 626.910156 566.929688 C 626.910156 565.535156 626.355469 564.175781 625.367188 563.195312 C 624.386719 562.21875 623.027344 561.648438 621.636719 561.648438 L 207.644531 561.648438 C 206.253906 561.648438 204.894531 562.207031 203.917969 563.195312 C 202.929688 564.175781 202.371094 565.535156 202.371094 566.929688 L 202.371094 640.398438 C 202.359375 649.019531 206.398438 656.761719 212.597656 662.152344 C 218.808594 667.574219 227.210938 670.8125 236.410156 670.8125 L 592.875 670.8125 C 602.0625 670.8125 610.476562 667.574219 616.683594 662.152344 C 622.886719 656.761719 626.921875 649.019531 626.910156 640.398438 L 621.636719 640.398438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#34928fb3b3)">
        <path
          fill={color}
          d="M 207.644531 255.0625 L 621.636719 255.0625 L 621.636719 396.542969 L 207.644531 396.542969 L 207.644531 255.0625 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#fb857bd0c6)">
        <path
          fill="#fdfdfd"
          d="M 207.644531 255.0625 L 207.644531 260.339844 L 616.367188 260.339844 L 616.367188 391.265625 L 212.917969 391.265625 L 212.917969 255.0625 L 207.644531 255.0625 L 207.644531 260.339844 L 207.644531 255.0625 L 202.371094 255.0625 L 202.371094 396.542969 C 202.371094 397.953125 202.917969 399.273438 203.917969 400.273438 C 204.914062 401.273438 206.234375 401.820312 207.644531 401.820312 L 621.636719 401.820312 C 623.050781 401.820312 624.367188 401.273438 625.367188 400.273438 C 626.367188 399.273438 626.910156 397.953125 626.910156 396.542969 L 626.910156 255.0625 C 626.910156 253.671875 626.355469 252.308594 625.367188 251.328125 C 624.386719 250.351562 623.027344 249.785156 621.636719 249.785156 L 207.644531 249.785156 C 206.253906 249.785156 204.894531 250.339844 203.917969 251.328125 C 202.929688 252.308594 202.371094 253.671875 202.371094 255.0625 L 207.644531 255.0625 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default memo(TrailerIcon);
